
import Vue from 'vue';
import Podcast from '@root/modules/podcast/components/fragments/Podcast.vue';
import { Podcast as IPodcast } from '@root/modules/podcast/types/podcast';
import getPodcastWithHref from '@root/modules/podcast/utils/getPodcastWithHref';
import Swiper from '@core/components/UI/swiper/Swiper.vue';
import LinkHandler from '@core/components/helpers/LinkHandler.vue';
import isMobileView from '@root/common/utils/isMobileView';

interface Props {
  data: IPodcast[];
}

interface Data {
  isMobileView: boolean;
  swiperOptions: Record<string, any>;
}

interface Computed {
  items: IPodcast[];
}

export default Vue.extend<Data, unknown, Computed, Props>({
  components: {
    Podcast,
    Swiper,
    LinkHandler,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isMobileView: false,
      swiperOptions: {
        spaceBetween: 24,
        initialSlide: 0,
        autoplay: false,
        loop: false,
        slidesPerView: 2.5,
        slidesPerGroup: 1,
        pagination: {
          enabled: false,
        },
        navigation: {
          enabled: false,
        },
        scrollbar: {
          enabled: false,
        },
        simulateTouch: false,
        breakpoints: {
          768: {
            freeMode: false,
            slidesPerView: 4,
            slidesPerGroup: 4,
          },
          1230: {
            freeMode: false,
            slidesPerView: 6,
            slidesPerGroup: 6,
          },
        },
      },
    };
  },
  computed: {
    items() {
      let data = [...this.data];

      if (this.data.length) {
        const fakeDomainEnabled = this.$config.FAKE_DOMAIN_ENABLED;
        const podcastsWithHref = data.map((podcast: IPodcast) => {
          const { domain } = this.$channelConfig('settings');
          return getPodcastWithHref({ podcast, domain, fakeDomainEnabled });
        });

        data = podcastsWithHref;
      }

      return data;
    },
  },
  mounted() {
    this.isMobileView = isMobileView();
  },
});
